import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showProductLoader,
    onSaveProduct,
    onProductClose,
} from 'actions/product';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const ProductAdd = () => {
    const dispatch = useDispatch();
    const addProductState = useSelector(state => state.products.addProductState);
    const allValueStreams = useSelector(state => state.valueStreams.allValueStream);
    const allMembers = useSelector(state => state.members.allMember);
    const allBusinessUnits = useSelector(state => state.businessUnits.allBusinessUnit);
    const [selectedProduct, setSelectedProduct] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedProduct(initProps());
    }, [addProductState]);

    // using selectedProduct makes it behave like componentDidUpdate - effect takes place when selectedProduct changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedProduct]);

    const initProps = () => {
        return {
            id: '',
            orgid: '',
            name: '',
            description: '',
            manager: '',
            fyBudget: 0,
            businessUnitId: '',
            valueStreamId: '',
            productType: '',
            starred: false,
            frequently: false,
        };
    };

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedProductField(name, value);
        validateField(name, value);
    };

    const updateSelectedProductField = (fieldName, value) => {
        const newProduct = { ...selectedProduct };
        newProduct[fieldName] = value;
        setSelectedProduct(newProduct);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedProduct));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showProductLoader());
                dispatch(onProductClose());
                dispatch(onSaveProduct(selectedProduct));
                setSelectedProduct(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onProductClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedProduct)}
                        {showErrors(formErrors)}
                        {inputFields(selectedProduct, allValueStreams, allBusinessUnits, allMembers, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addProductState}>
            {modalHeader(<IntlMessages id="product.addProduct" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="product.addProduct" />)}
        </Modal>
    );
};

export default ProductAdd;


// WEBPACK FOOTER //
// ./components/Agile/product/productMaintenance/productAdd/index.js